﻿const DIACRITICS = /[\u0300-\u036f]/g
const TOKEN_RE = /[\p{L}\p{N}]+/gu

export function normalizeText(value: string): string {
  return value
    .normalize('NFD')
    .replace(DIACRITICS, '')
    .toLocaleLowerCase('en-US')
    .trim()
}

export function tokenize(value: string): string[] {
  const normalized = normalizeText(value)
  const matches = normalized.match(TOKEN_RE) ?? []
  return [...new Set(matches.filter((token) => token.length >= 2))]
}

export function normalizeTags(tags: string[]): string[] {
  const seen = new Set<string>()
  const result: string[] = []

  for (const raw of tags) {
    const display = raw.trim().replace(/\s+/g, ' ')
    const key = normalizeText(display)
    if (!display || !key || seen.has(key)) continue
    seen.add(key)
    result.push(display)
  }

  return result
}

export function parseTags(value: string): string[] {
  return normalizeTags(value.split(/[,;\n]/))
}

export function buildImageTokens(title: string, description: string, tags: string[]): string[] {
  return tokenize(`${title} ${description} ${tags.join(' ')}`)
}

export function sanitizeFileSegment(value: string, fallback = 'untitled'): string {
  const cleaned = value
    .normalize('NFKC')
    .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '-')
    .replace(/\.+$/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, 120)

  return cleaned || fallback
}

export function fileExtension(fileName: string, mimeType = ''): string {
  const match = fileName.match(/\.([a-zA-Z0-9]{1,10})$/)
  if (match) return match[1].toLowerCase()

  const byMime: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'image/avif': 'avif',
    'image/svg+xml': 'svg'
  }
  return byMime[mimeType] ?? 'img'
}

export function fileStem(fileName: string): string {
  return fileName.replace(/\.[^.]+$/, '') || fileName
}
